import styled from 'styled-components';

export const StyledSection = styled.section`
  gap: 10px;
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  height: 100%;
`;
